import {
  ButtonDS,
  ModalDS,
  Spacer,
  TextCapitalized,
  WarningOutlined,
} from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import "../../../i18n/i18n";

type DeleteCompanyModalProps = {
  visible: boolean;
  onClose: () => void;
  selectedCompanyName?: string;
  onConfirm: () => void;
};

export interface DeleteCompanyModalState {
  isVisible: boolean;
  companyUuid?: string;
  name?: string;
}

export const DeleteCompanyModal = ({
  visible,
  onClose,
  selectedCompanyName,
  onConfirm,
}: DeleteCompanyModalProps) => {
  const { t } = useTranslation();

  return (
    <ModalDS visible={visible} onClose={onClose} width={300}>
      <StyledModalContainer>
        <StyledIcon>
          <WarningOutlined />
        </StyledIcon>
        <Spacer y={2} />
        <StyledModalTitle>
          <TextCapitalized>
            {t(`companyFollowUp.deleteCompany.modal.title`, {
              name: selectedCompanyName,
            })}
          </TextCapitalized>
        </StyledModalTitle>
        <Spacer y={1} />
        <StyledModalText>
          <TextCapitalized>
            {t(`companyFollowUp.deleteCompany.modal.alert`, {
              name: selectedCompanyName,
            })}
          </TextCapitalized>
        </StyledModalText>
        <Spacer y={2} />
        <StyledButtonContainer>
          <ButtonDS
            text={t(`companyFollowUp.deleteCompany.modal.cancelButton`)}
            format="fill"
            buttonType="secondary"
            onClick={onClose}
          />
          <Spacer x={1} />
          <ButtonDS
            text={t(`companyFollowUp.deleteCompany.modal.confirmButton`)}
            format="fill"
            buttonType="danger"
            onClick={onConfirm}
          />
          <Spacer y={2} />
        </StyledButtonContainer>
      </StyledModalContainer>
    </ModalDS>
  );
};

const StyledModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const StyledModalTitle = styled.div`
  ${typographies["Header/H3"]};
  text-align: center;
  color: ${colors["colors/text/black"]};
`;

const StyledModalText = styled.div`
  ${typographies["Body/M"]};
  text-align: center;
  color: ${colors["colors/text/darkGrey"]};
`;

const StyledIcon = styled.div`
  & svg {
    width: 3.5em;
    height: 3.5em;
  }
  height: 4rem;
  width: 4rem;
  border-radius: 0.5rem;
  fill: ${colors["colors/system/error/error_normal"]};
  justify-content: center;
  display: flex;
  align-items: center;
`;

const StyledButtonContainer = styled.div`
  display: flex;
  width: 100%;
`;
